import React from 'react';

import { token } from '@atlaskit/tokens';

const SPACING_TO_SIZE = {
	none: 16,
	spacious: 20,
} as const;

type Spacing = keyof typeof SPACING_TO_SIZE;

export type PageMarkdownIconProps = {
	label: string;
	color?: string;
	spacing?: Spacing;
	testId?: string;
};

/**
 * Markdown variant of the live-doc page icon. Used in content trees and other
 * compact icon slots when a live page is in markdown mode.
 */
export const PageMarkdownIcon = ({
	label,
	color,
	spacing = 'none',
	testId,
}: PageMarkdownIconProps) => {
	const size = SPACING_TO_SIZE[spacing];
	const stroke = color ?? token('color.icon.subtle');

	const hasLabel = label.length > 0;

	return (
		<svg
			data-testid={testId}
			width={size}
			height={size}
			{...(hasLabel ? { 'aria-label': label, role: 'img' } : { 'aria-hidden': true })}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.0625 6.5625H8.4375V0.9375M14.0625 6.5625V10M14.0625 6.5625C14.0625 6.16232 13.9035 5.77853 13.6206 5.49556L9.50444 1.37944C9.22147 1.09647 8.83768 0.9375 8.4375 0.9375M8.4375 0.9375H2.5C1.63705 0.9375 0.9375 1.63706 0.9375 2.5V17.5C0.9375 18.3629 1.63706 19.0625 2.5 19.0625"
				stroke={stroke}
				strokeWidth="1.875"
				strokeLinejoin="round"
			/>
			<path
				d="M5.9375 20V13.4375H6.40625L8.75 17.8125L11.0938 13.4375H11.5625V20"
				stroke={stroke}
				strokeWidth="1.875"
				strokeLinejoin="round"
			/>
			<path
				d="M16.5625 13.5V19.0625M16.5625 19.0625L19.0625 16.5625M16.5625 19.0625L14.0625 16.5625"
				stroke={stroke}
				strokeWidth="1.875"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
